import { ArrowRight } from 'lucide-react'
import { CalmBlock, CalmItem } from '../components/CalmMotion'
import { Link } from 'react-router-dom'
import { NewsArticleCard } from '../components/news/NewsArticleCard'
import { getNewsPosts } from '../data/newsPosts'
import { useT } from '../i18n/t'
import { NEWS_BASE_PATH, newsArticlePath } from '../lib/newsPaths'

const LANDING_FEATURED_COUNT = 3

export function LandingNewsSection({ calm }: { calm?: boolean } = {}) {
  const { t } = useT()
  const posts = getNewsPosts().slice(0, LANDING_FEATURED_COUNT)
  const gridCols =
    posts.length === 1
      ? 'md:grid-cols-1 md:mx-auto md:max-w-md'
      : posts.length === 2
        ? 'md:grid-cols-2'
        : 'md:grid-cols-3'

  return (
    <section id="aktualnosci" className="container-x py-14 md:py-20">
      <CalmBlock calm={calm} viewportAmount={0.15} className="content">
        <CalmItem calm={calm}>
          <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-ink/45">
            {t('news.section.eyebrow')}
          </p>
          <h2 className="display mt-3 text-[28px] font-bold leading-[1.1] text-ink md:text-[40px]">
            {t('news.section.title')}
          </h2>
          <p className="mt-2 max-w-[60ch] text-[15px] font-medium text-ink/60 md:text-base">
            {t('news.section.subtitle')}
          </p>
        </CalmItem>

        <div className={`mt-8 grid grid-cols-1 gap-8 md:mt-12 md:gap-6 ${gridCols}`}>
          {posts.map((post) => (
            <CalmItem key={post.id} calm={calm}>
              <NewsArticleCard post={post} articlePath={newsArticlePath(post.slug)} />
            </CalmItem>
          ))}
        </div>

        <CalmItem calm={calm} className="mt-10 flex justify-center md:mt-12">
          <Link
            to={NEWS_BASE_PATH}
            className="inline-flex h-12 items-center gap-2 rounded-lg bg-ink px-8 text-sm font-extrabold text-paper transition hover:bg-ink/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/60"
          >
            {t('news.section.ctaAll')}
            <ArrowRight className="h-4 w-4" aria-hidden />
          </Link>
        </CalmItem>
      </CalmBlock>
    </section>
  )
}
